var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftCard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.813 6.983a1.467 1.467 0 00.535-1.979 1.466 1.466 0 00-2.018-.2c-.69.487-1.1 1.305-1.473 2.253h2.856l.1-.074zM9.64 4.817A1.467 1.467 0 007.608 5a1.47 1.47 0 00.517 1.97l.148.087h2.822c-.374-.93-.783-1.761-1.457-2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-75",
    d: "M20.283 7.057h-3.31a2.33 2.33 0 00.08-2.535l-.031-.048a2.335 2.335 0 00-3.235-.37c-.909.64-1.383 1.661-1.822 2.779-.435-1.118-.913-2.135-1.804-2.766a2.335 2.335 0 00-3.248.357l-.035.052c-.46.79-.423 1.774.096 2.526H3.739c-.88 0-1.593.712-1.596 1.591v10.118c.003.88.716 1.593 1.596 1.596h16.565a1.601 1.601 0 001.596-1.596V8.648a1.595 1.595 0 00-1.617-1.591zm.726 11.704c0 .4-.325.726-.726.726H3.739a.727.727 0 01-.726-.726V8.648a.723.723 0 01.726-.722h16.565a.722.722 0 01.726.722V18.76h-.021zm-6.7-13.957a1.465 1.465 0 012.017.2c.393.69.166 1.567-.513 1.979l-.122.074h-2.856c.374-.93.782-1.766 1.474-2.253zM8.126 6.978A1.469 1.469 0 017.61 5a1.465 1.465 0 012.03-.183c.674.479 1.083 1.305 1.457 2.24H8.274l-.148-.079z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-75",
    d: "M2.991 9.583h18.013v3.139H2.991zm15.431 5.265a.821.821 0 00-.696.47.827.827 0 00-.691-.475h-.1c-1.013 0-1.957 1.57.782 3.214 2.844-1.705 1.753-3.34.705-3.21z"
  }))));
}

export default SvgGiftCard;